// extracted by mini-css-extract-plugin
export default {"modal":"copy-bag-modal_modal__RDdZ5"};